module.exports = __webpack_public_path__ + "static/media/planszka_v3.4cfed805.png";